import { Component, OnInit } from '@angular/core';
import { ServiceWorkerService } from './service-worker.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'TripleSData';

  constructor(private swService: ServiceWorkerService) {}

  async ngOnInit(): Promise<void> {
    await this.swService.deregisterServiceWorkerIfExists();
  }
}
